enum OrderImageType {
  Qr = 1,
  BarCode = 2,
  ContactQr = 3,
}

export default OrderImageType;
